import React from 'react';
import { FiArrowUp } from 'react-icons/fi';
import classnames from 'classnames';

import './go-top.styles.scss';

const GoTop: React.FC = () => {
  const [goTopIsVisible, setGoTopIsVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    document.addEventListener('scroll', () => {
      if (window.scrollY > 170) {
        setGoTopIsVisible(true);
      } else {
        setGoTopIsVisible(false);
      }
    });
  }, []);

  const goToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };

  const renderGoTopIcon = () => {
    if (goTopIsVisible) {
      return (
        <div
          className={classnames('go-top', { active: goTopIsVisible })}
          onClick={goToTop}
        >
          <FiArrowUp />
        </div>
      );
    }
  };
  return <>{renderGoTopIcon()}</>;
};

export default GoTop;
